import Linkify from 'linkify-react'
import { find } from 'linkifyjs'

/**
 * Converts URLs in text to clickable links using linkifyjs
 */
export function LinkifiedText({ children }: { children: string }) {
  return (
    <Linkify
      options={{
        target: '_blank',
        rel: 'noopener noreferrer',
        className: 'underline hover:no-underline',
      }}
    >
      {children}
    </Linkify>
  )
}

/**
 * Extract the first URL from text (for preview)
 */
export function extractFirstUrl(text: string): string | null {
  if (!text) return null
  const links = find(text, 'url')
  return links.length > 0 ? links[0].href : null
}

/**
 * Legacy function wrapper for compatibility
 */
export function linkify(text: string): React.ReactNode {
  return <LinkifiedText>{text}</LinkifiedText>
}
